import { color, mix, smoothstep, uniform, uv } from "three/tsl"
import * as THREE from "three/webgpu"
import { FolderApi } from "tweakpane"

export class Sky {
  scene: THREE.Object3D
  debugFolder?: FolderApi

  settings: {
    colorTop: THREE.UniformNode<THREE.Color>
    colorBottom: THREE.UniformNode<THREE.Color>
    transitionY: THREE.UniformNode<number>
  }

  constructor({
    scene,
    debugFolder,
    colorTop = "#0d5695",
    colorBottom = "#9b4a10",
    transitionY = 0.45,
  }: {
    scene: THREE.Object3D
    debugFolder?: FolderApi
    colorTop?: string
    colorBottom?: string
    transitionY?: number
  }) {
    this.scene = scene
    this.debugFolder = debugFolder

    this.settings = {
      colorTop: uniform(color(colorTop)),
      colorBottom: uniform(color(colorBottom)),
      transitionY: uniform(transitionY),
    }

    this.setMesh()

    this.setDebug()
  }

  setMesh() {
    const geometry = new THREE.SphereGeometry(500, 32, 32)

    const material = new THREE.MeshBasicNodeMaterial()

    const uvCoordinates = uv()

    const smoothTransition = smoothstep(
      this.settings.transitionY.sub(SKY_TRANSITION_WIDTH / 2),
      this.settings.transitionY.add(SKY_TRANSITION_WIDTH / 2),
      uvCoordinates.y,
    )

    const gradient = mix(
      this.settings.colorBottom,
      this.settings.colorTop,
      smoothTransition,
    )

    material.colorNode = gradient
    material.side = THREE.BackSide
    material.fog = false

    const mesh = new THREE.Mesh(geometry, material)
    this.scene.add(mesh)
  }

  update() {}

  setDebug() {
    if (this.debugFolder) {
      const settings = {
        colorTop: `#${new THREE.Color(this.settings.colorTop.value).getHexString()}`,
        colorBottom: `#${new THREE.Color(this.settings.colorBottom.value).getHexString()}`,
        transitionY: this.settings.transitionY.value,
      }

      const folder = this.debugFolder.addFolder({
        title: "🌤️ Sky",
        expanded: false,
      })

      folder.addBinding(settings, "colorTop").on("change", (ev) => {
        this.settings.colorTop.value = new THREE.Color(ev.value)
      })
      folder.addBinding(settings, "colorBottom").on("change", (ev) => {
        this.settings.colorBottom.value = new THREE.Color(ev.value)
      })

      folder
        .addBinding(settings, "transitionY", {
          min: 0,
          max: 1,
          step: 0.001,
        })
        .on("change", (ev) => {
          this.settings.transitionY.value = ev.value
        })
    }
  }
}

const SKY_TRANSITION_WIDTH = 0.3
